var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.86524 11.1873C7.88125 11.2077 7.9017 11.2243 7.92505 11.2357C7.9484 11.247 7.97403 11.2529 8 11.2529C8.02597 11.2529 8.0516 11.247 8.07495 11.2357C8.0983 11.2243 8.11875 11.2077 8.13476 11.1873L10.5305 8.15627C10.6182 8.04504 10.539 7.88033 10.3957 7.88033H8.8107V0.641826C8.8107 0.547708 8.73369 0.470703 8.63957 0.470703H7.35615C7.26203 0.470703 7.18503 0.547708 7.18503 0.641826V7.87819H5.60428C5.46096 7.87819 5.38182 8.0429 5.46952 8.15413L7.86524 11.1873ZM15.8289 10.4386H14.5455C14.4513 10.4386 14.3743 10.5156 14.3743 10.6097V13.9039H1.62567V10.6097C1.62567 10.5156 1.54866 10.4386 1.45455 10.4386H0.171123C0.0770053 10.4386 0 10.5156 0 10.6097V14.845C0 15.2236 0.305882 15.5295 0.684492 15.5295H15.3155C15.6941 15.5295 16 15.2236 16 14.845V10.6097C16 10.5156 15.923 10.4386 15.8289 10.4386Z",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.f5b7e7846c79eea840c28f87d4857274.svg";
export { ForwardRef as ReactComponent };